import { Outlet, NavLink, Link } from 'react-router-dom';
import api from '../services/api';
import {
  limpiarSesionAuth,
  obtenerUsuarioSesion
} from '../utils/sesion';

function obtenerUsuarioLayout() {
  return obtenerUsuarioSesion();
}

function AdminLayout({ soloCajaChica = false }) {
  const usuario = obtenerUsuarioLayout();

  const nombreUsuario =
    usuario.Nombre ||
    usuario.Usuario ||
    usuario.Rol ||
    usuario.rol ||
    'Usuario';

  const rol = usuario.Rol || usuario.rol || '';
  const mostrarSoloCajaChica = soloCajaChica || rol === 'CajaChica';

  const linkClass = ({ isActive }) =>
    `nav-link px-3 py-2 rounded ${
      isActive ? 'text-white' : 'text-white'
    }`;

  async function cerrarSesion() {
    try {
      await api.post('/auth/logout');
    } catch {
      // La salida local no debe bloquearse si el backend no registra logout.
    } finally {
      limpiarSesionAuth();

      window.location.href = '/login';
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f4f6f9'
      }}
    >
      <header
        style={{
          background: '#294257',
          borderBottom: '1px solid rgba(255,255,255,0.10)',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          boxShadow: '0 2px 4px rgba(0,0,0,0.10)'
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '1500px',
            margin: '0 auto',
            padding: '8px 18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '18px',
            flexWrap: 'wrap'
          }}
        >
          <Link
            to={mostrarSoloCajaChica ? "/caja-chica" : "/dashboard"}
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none'
            }}
          >
            <div
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '10px',
                overflow: 'hidden',
                background: 'rgba(255,255,255,0.00)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0.2px'
              }}
            >
              <img
                src="/logo-app.png"
                alt="Logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
              />
            </div>

            <div
              style={{
                fontWeight: '700',
                fontSize: '20px',
                color: '#ffffff',
                whiteSpace: 'nowrap',
                letterSpacing: '0.2px',
                marginLeft: '10px'
              }}
            >
              Control Recibos
            </div>
          </Link>

          <nav
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap'
            }}
          >
            {(mostrarSoloCajaChica
              ? [['/caja-chica', 'Caja Chica']]
              : [
                ['/dashboard', 'Dashboard'],
                ['/recibos', 'Recibos'],
                ['/historico', 'Histórico'],
                ['/caja', 'Caja'],
                ['/caja-chica', 'Caja Chica'],
                ['/configuracion', 'Configuración']
              ]).map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                className={linkClass}
                style={({ isActive }) => ({
                  background: isActive ? '#1b82d6' : 'transparent',
                  transition: 'all 0.2s ease',
                  fontWeight: '500',
                  fontSize: '14px'
                })}
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              flexWrap: 'wrap'
            }}
          >
            <span
              style={{
                color: '#ffffff',
                fontSize: '14px',
                opacity: 0.9
              }}
            >
              Usuario: {nombreUsuario}
            </span>

            <button
              className="btn btn-sm btn-outline-light"
              type="button"
              onClick={cerrarSesion}
            >
              Salir
            </button>
          </div>

        </div>
      </header>

      <main
        style={{
          width: '100%',
          padding: '18px'
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;



